import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getAvatarFrame,
  deleteAvatarFrame,
} from "../../store/AvatarFrame/action";
import { Link } from "react-router-dom";
import { OPEN_DIALOGUE_AVATAR_FRAME } from "../../store/AvatarFrame/type";
import AvatarDialogue from "../dialog/AvatarDialogue";
import { baseURL } from "../../util/Config";
import { warning } from "../../util/Alert";
import noImage from "../../assets/images/noImage.png";
import SVGA from "svgaplayerweb";
import $ from "jquery";

const Avatar = (props) => {
  const { avatarFrame } = useSelector((state) => state.avatarFrame);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(getAvatarFrame("frame"));
  }, [dispatch]);

  useEffect(() => {
    setData(avatarFrame);
  }, [avatarFrame]);

  useEffect(() => {
    if (data && data.length > 0) {
      data.map((item, index) => {
        if (item?.image?.split(".").pop() === "svga") {
          const player = new SVGA.Player(`div[attr="${index}"]`);
          const parser = new SVGA.Parser();
          parser.load(baseURL + item?.image, (videoItem) => {
            player.setVideoItem(videoItem);
            player.startAnimation();
          });
        }
      });
    }
  }, [data]);

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase()
      ? e.target.value.trim().toUpperCase()
      : e.target.value.trim();
    if (value) {
      const filtered = avatarFrame.filter((d) =>
        d?.diamond?.toString()?.indexOf(value) > -1 ||
        d?.name?.toUpperCase()?.indexOf(value) > -1
      );
      setData(filtered);
    } else {
      setData(avatarFrame);
    }
  };

  const handleDelete = (id) => {
    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteAvatarFrame(id);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleOpen = () => {
    dispatch({ type: OPEN_DIALOGUE_AVATAR_FRAME });
  };

  const handleEdit = (data) => {
    dispatch({ type: OPEN_DIALOGUE_AVATAR_FRAME, payload: data });
  };

  $(document).ready(function () {
    $("img").bind("error", function () {
      $(this).attr("src", noImage);
    });
  });

  return (
    <>
      {/* Page Title */}
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-dark">Avatar Frame</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">Avatar Frame</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="main-wrapper">
        {/* Toolbar */}
        <div className="d-flex align-items-center justify-content-between flex-wrap mb-4" style={{ gap: "12px" }}>
          <button
            type="button"
            id="bannerDialog"
            onClick={handleOpen}
            style={{
              padding: "9px 22px", border: "none", borderRadius: "10px",
              background: "linear-gradient(135deg, #f5576c, #f093fb)",
              color: "#fff", fontWeight: 700, fontSize: "14px",
              cursor: "pointer", letterSpacing: "0.4px",
              boxShadow: "0 4px 14px rgba(245,87,108,0.35)"
            }}
          >
            <i className="fa fa-plus" style={{ marginRight: "7px" }}></i>New Frame
          </button>
          <div style={{
            display: "flex", alignItems: "center",
            background: "#fff", borderRadius: "12px",
            padding: "6px 16px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
            minWidth: "240px"
          }}>
            <i className="fas fa-search" style={{ color: "#aaa", marginRight: "8px" }}></i>
            <input
              type="search"
              placeholder="Search frames..."
              style={{ border: "none", outline: "none", fontSize: "14px", width: "100%", background: "transparent" }}
              onChange={handleSearch}
            />
          </div>
        </div>

        {/* Card Grid */}
        <div className="row g-4">
          {data?.length > 0 ? (
            data.map((item, index) => (
              <div className="col-12 col-sm-6 col-md-4 col-xl-3" key={index}>
                <div
                  style={{
                    borderRadius: "18px", overflow: "hidden",
                    background: "#fff",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                    transition: "transform 0.22s ease, box-shadow 0.22s ease",
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 16px 40px rgba(0,0,0,0.16)";
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 24px rgba(0,0,0,0.08)";
                  }}
                >
                  {/* Media Header */}
                  <div style={{
                    background: "linear-gradient(145deg, #0f0c29, #302b63, #24243e)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    height: "190px", position: "relative",
                  }}>
                    {item?.exclusive && (
                      <span style={{
                        position: "absolute", top: 10, right: 10,
                        background: "linear-gradient(135deg, #f7971e, #ffd200)",
                        color: "#1a1a2e", fontSize: "10px", fontWeight: 800,
                        padding: "3px 9px", borderRadius: "20px"
                      }}>★ EXCLUSIVE</span>
                    )}
                    {item?.image?.split(".")?.pop() !== "svga" ? (
                      <img
                        src={item?.image ? baseURL + item?.image : noImage}
                        alt={item?.name}
                        style={{
                          width: "150px", height: "150px", objectFit: "contain",
                          filter: "drop-shadow(0 6px 16px rgba(255,255,255,0.12))"
                        }}
                      />
                    ) : (
                      <div id="svga" attr={index} style={{ width: "150px", height: "150px" }}></div>
                    )}
                  </div>

                  {/* Card Body */}
                  <div style={{ padding: "16px 18px 18px" }}>
                    <h6 style={{
                      fontWeight: 700, fontSize: "15px", color: "#1a1a2e",
                      textAlign: "center", marginBottom: "12px",
                      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
                    }}>
                      {item?.name || "—"}
                    </h6>

                    <div style={{ display: "flex", gap: "8px", justifyContent: "center", flexWrap: "wrap", marginBottom: "16px" }}>
                      <span style={{
                        background: "#fff8e1", color: "#e65100",
                        padding: "4px 12px", borderRadius: "20px",
                        fontSize: "12px", fontWeight: 700
                      }}>💎 {item?.diamond}</span>
                      <span style={{
                        background: "#e3f2fd", color: "#1565c0",
                        padding: "4px 12px", borderRadius: "20px",
                        fontSize: "12px", fontWeight: 700
                      }}>⏱ {item?.validity} {item?.validityType}</span>
                    </div>

                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        onClick={() => handleEdit(item)}
                        style={{
                          flex: 1, padding: "9px 0", border: "none", borderRadius: "10px",
                          background: "linear-gradient(135deg, #667eea, #764ba2)",
                          color: "#fff", fontWeight: 600, fontSize: "13px", cursor: "pointer",
                          display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
                        }}
                      >
                        <i className="fas fa-edit" style={{ fontSize: "12px" }}></i>Edit
                      </button>
                      <button
                        onClick={() => handleDelete(item?._id)}
                        style={{
                          flex: 1, padding: "9px 0", border: "none", borderRadius: "10px",
                          background: "linear-gradient(135deg, #f5576c, #f093fb)",
                          color: "#fff", fontWeight: 600, fontSize: "13px", cursor: "pointer",
                          display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
                        }}
                      >
                        <i className="fas fa-trash" style={{ fontSize: "12px" }}></i>Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <i className="fas fa-images" style={{ fontSize: "56px", color: "#e0e0e0", display: "block", marginBottom: "16px" }}></i>
              <p style={{ color: "#bbb", fontSize: "16px" }}>No avatar frames found.</p>
            </div>
          )}
        </div>
      </div>

      <AvatarDialogue />
    </>
  );
};

export default connect(null, { getAvatarFrame, deleteAvatarFrame })(Avatar);
